/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
import cx from 'classnames';
import * as React from 'react';
import { useSafeContext, useMergedRefs } from '../utils/index.js';
import { ComboBoxStateContext } from './helpers.js';
export const ComboBoxMenuItem = React.memo(React.forwardRef((props, forwardedRef) => {
    const { children, isSelected, disabled, value, onClick, sublabel, size = !!sublabel ? 'large' : 'default', icon, badge, className, role = 'option', index, ...rest } = props;
    const { focusedIndex, enableVirtualization } = useSafeContext(ComboBoxStateContext);
    const focusRef = (el) => {
        if (!enableVirtualization && focusedIndex === index) {
            el === null || el === void 0 ? void 0 : el.scrollIntoView({ block: 'nearest' });
        }
    };
    const refs = useMergedRefs(forwardedRef, focusRef);
    return (React.createElement("li", { className: cx('iui-menu-item', {
            'iui-large': size === 'large',
            'iui-active': isSelected,
            'iui-disabled': disabled,
            'iui-focused': focusedIndex === index,
        }, className), ref: refs, onClick: () => onClick === null || onClick === void 0 ? void 0 : onClick(value), role: role, tabIndex: role === 'presentation' ? undefined : -1, "aria-selected": isSelected, "aria-disabled": disabled, "data-iui-index": index, ...rest },
        icon &&
            React.cloneElement(icon, {
                className: cx(icon.props.className, 'iui-icon'),
            }),
        React.createElement("span", { className: 'iui-content' },
            React.createElement("div", { className: 'iui-menu-label' }, children),
            sublabel && React.createElement("div", { className: 'iui-menu-description' }, sublabel)),
        badge &&
            React.cloneElement(badge, {
                className: cx(badge.props.className, 'iui-icon'),
            })));
}));
ComboBoxMenuItem.displayName = 'ComboBoxMenuItem';
